import type { FaireProductEntity } from "../../entity_types/product";

export const p_qbmn3vbneu: FaireProductEntity = {
  token: "p_qbmn3vbneu",
  type: "product",
  name: '(PK 2) MEDITATION CHARGER CYLINDER - COPPER (PK 2) 1.5"DIA.',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fc0176db7ce47cc890467cd42db1028bdc048f59c3987b85f0fedf3a8045b971.jpeg",
  galleryImageUrls: [],
  priceDollars: 32.01,
  description:
    '(PK 2) MEDITATION CHARGER CYLINDER - COPPER (PK 2) 1.5"DIA. X 4"H',
  tags: [],
  msrpDollars: 64.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:18.984Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
